import { render, staticRenderFns } from "./tab-nav-item.vue?vue&type=template&id=6328883e&scoped=true&"
import script from "./tab-nav-item.vue?vue&type=script&lang=js&"
export * from "./tab-nav-item.vue?vue&type=script&lang=js&"
import style0 from "./tab-nav-item.vue?vue&type=style&index=0&id=6328883e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6328883e",
  null
  
)

export default component.exports